import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-help-container',
  templateUrl: './help-container.component.html',
  styleUrls: ['./help-container.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class HelpContainerComponent {

}
